//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import ProviderPaymentSheetCreate from '@/views/Purchase/PchProviderPaymentSheet/ProviderPaymentSheetCreate'
import ProviderPaymentSheetList from '@/views/Purchase/PchProviderPaymentSheet/ProviderPaymentSheetList'
import ProviderPaymentSheetUpdate from '@/views/Purchase/PchProviderPaymentSheet/ProviderPaymentSheetUpdate'

//
export default {
    path: 'provider_payment_sheet',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'provider-payment-sheet-list',
            component: ProviderPaymentSheetList,
        },
        {
            path: 'create',
            name: 'provider-payment-sheet-create',
            component: ProviderPaymentSheetCreate,
            meta: {
                title: 'Crear nomina de pago',
            },
        },
        {
            path: ':id',
            name: 'provider-payment-sheet-update',
            component: ProviderPaymentSheetUpdate,
            meta: {
                title: 'Detalle de nómina de pago',
            },
        },
    ],
    meta: {
        title: 'Nóminas de pago',
    },
}
